import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _PaymentPagesFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8701 2.52637C16.1541 3.26145 16.1543 4.44157 16.8701 5.17676C17.2745 5.59193 17.8215 5.77694 18.3535 5.7334V8C18.3535 9.01535 19.1624 9.88848 20.2217 9.88867C21.0729 9.88867 21.7617 9.3245 22 8.57617V19.8887C22 21.116 21.0046 22.1113 19.7773 22.1113H4.22266C2.99536 22.1113 2 21.116 2 19.8887V4.33398C2 3.10669 2.99536 2.11133 4.22266 2.11133H17.2744L16.8701 2.52637ZM6.44434 16.834C5.98415 16.834 5.61133 17.2068 5.61133 17.667C5.61145 18.1271 5.98422 18.4999 6.44434 18.5H15.333C15.7932 18.5 16.1669 18.1271 16.167 17.667C16.167 17.2068 15.7932 16.834 15.333 16.834H6.44434ZM6.44434 12.3896C5.98415 12.3897 5.61133 12.7625 5.61133 13.2227C5.6115 13.6827 5.98426 14.0556 6.44434 14.0557H10.8887C11.3488 14.0557 11.7215 13.6827 11.7217 13.2227C11.7217 12.7624 11.3489 12.3896 10.8887 12.3896H6.44434Z"
        fill={iconColor}
      />
      <Path
        d="M18.0693 4.61621C18.0652 4.61546 18.0608 4.61606 18.0566 4.61523L18.0322 4.60742C18.0446 4.61025 18.0568 4.61394 18.0693 4.61621Z"
        fill={iconColor}
      />
      <Path
        d="M19.4645 8.00001V3.65546L18.7375 4.40183C18.4416 4.70557 17.9621 4.70557 17.6662 4.40183C17.3704 4.0981 17.3704 3.60576 17.6662 3.30202L19.6864 1.22798L19.7436 1.17431C20.0412 0.925103 20.4803 0.943213 20.7577 1.22798L22.7778 3.30202L22.8301 3.36076C23.0728 3.66625 23.0552 4.11706 22.7778 4.40183C22.5005 4.6866 22.0613 4.70471 21.7638 4.45551L21.7066 4.40183L20.9796 3.65546V8.00001C20.9796 8.42956 20.6404 8.77778 20.222 8.77778C19.8036 8.77778 19.4645 8.42956 19.4645 8.00001Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const PaymentPagesFilledIcon = assignWithoutSideEffects(_PaymentPagesFilledIcon, {
  componentId: 'PaymentPagesFilledIcon',
});

export default PaymentPagesFilledIcon;
